module.exports = __webpack_public_path__ + "assets/img/scroll.6341b800.webp";